/**
 * @lodex-pro/shared/wells-paging — the page-size cap for the well catalog search,
 * defined ONCE so no caller has to retype it.
 *
 * ── Why this module exists (OPEN-053) ───────────────────────────────────────
 * `GET /v1/wells/search` caps `limit` at 500. That ceiling exists because the
 * endpoint can be pointed at the ~131k-row global `wells` catalog, and it is
 * deliberately higher than a normal page so the bounded "My Catalog" view can
 * list a hauler's own wells with no search term at all (DEC-108).
 *
 * The number was a magic literal in two places — the server schema and the
 * `onlyMyCatalog` query string the dispatch client builds — and neither
 * mentioned the other. That let the bulk requestor editor request exactly 500
 * unfiltered wells and treat the answer as "the catalog", when for a hauler
 * with more than 500 wells it is the first 500 alphabetically and there is no
 * error, no flag, and nothing on screen to say so. A dispatcher selecting "all
 * of this customer's locations" would silently miss the rest.
 *
 * ── The cap is not the fix ──────────────────────────────────────────────────
 * Raising it just moves the cliff. The fix is to send the SEARCH TERM, so the
 * cap applies to the filtered set the dispatcher is actually working with, and
 * to say plainly when a result is truncated. Naming the number here is what
 * lets a caller detect that truncation at all: `rows.length >= cap`.
 */

/**
 * Max `limit` accepted by `GET /v1/wells/search`.
 *
 * A result whose length equals this is very likely TRUNCATED — the caller
 * should narrow the query rather than present it as complete.
 */
export const WELL_SEARCH_MAX_LIMIT = 500;
